/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentOtherDto
 */
export interface NovitusPaymentOtherDto {
    /**
     * Nazwa innej formy płatności
     * @type {string}
     * @memberof NovitusPaymentOtherDto
     */
    name: string;
    /**
     * Wartość innej formy płatności
     * @type {string}
     * @memberof NovitusPaymentOtherDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentOtherDto interface.
 */
export function instanceOfNovitusPaymentOtherDto(value: object): value is NovitusPaymentOtherDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentOtherDtoFromJSON(json: any): NovitusPaymentOtherDto {
    return NovitusPaymentOtherDtoFromJSONTyped(json, false);
}

export function NovitusPaymentOtherDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentOtherDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentOtherDtoToJSON(value?: NovitusPaymentOtherDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

